/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';

@Component({
  standalone: false,
  selector: 'adn-targeting-ip-address-summary',
  template: `
    <span>{{data30}}</span>
    <div *ngIf="hasRest > 0">
      <div>
        <a class="show-hide-link" (click)="showMore = !showMore"><span class="fa fa-fw fa-chevron-down" [ngClass]="{'fa-rotate-270': !showMore}"></span><span class="show-hide-label"><ng-container *ngIf="!showMore">Show</ng-container><ng-container *ngIf="showMore">Hide</ng-container> {{hasRest | stat}} remaining entries</span></a>
      </div>
      <div *ngIf="showMore" animate.enter="show-hide-enter" animate.leave="show-hide-leave">{{dataRest}}</div>
    </div>
  `
})
export class IpAddressSummaryComponent implements OnChanges {
  @Input() targets: any;

  data30 = '';
  dataRest = '';
  hasRest = 0;
  showMore = false;
  private readonly splitNum = 20;

  ngOnChanges(): void {
    const target = this.targets || {};
    const addresses = target.addresses || [];
    this.data30 = addresses.slice(0, this.splitNum).join(', ');
    this.dataRest = addresses.slice(this.splitNum).join(', ');
    this.hasRest = addresses.length - this.splitNum;
    this.showMore = false;
  }
}
